import { render } from "./Config.vue?vue&type=template&id=2ce9d1b0"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"
script.render = render

export default script